module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AgreementFormGeneral', {
    attrs: {
      "handleSubmit": _vm.handleSubmition,
      "values": _vm.item,
      "errors": _vm.violations,
      "initialValues": _vm.retrieved
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-483a8348","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/UpdateGeneral.vue
// module id = 813
// module chunks = 0